<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">
          12. INVERSIONES, CUENTAS BANCARIAS Y OTRO TIPO DE VALORES (SITUACIÓN
          ACTUAL)
        </h4>
      </b-col>
    </b-row>
    <br />
    <br />

    <b-list-group sm="12">
      <b-list-group-item
        v-for="(item, index) in valores.inversion"
        :key="index"
      >
        <b-col md="12">
          <div class="customHr">.</div>
        </b-col>
        <b-col md="12">
          <h5 style="text-align: center">Inversión</h5>
        </b-col>
        <b-col md="12">
          <div class="customHr">.</div>
        </b-col>

        <!-- Formulario -->
        <b-col md="12">
          <b-row>
             <b-col sm="3">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosInversion[index] = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
            <b-col md="4">
              <b-form-group label="Tipo de inversión: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  :options="tipoInversion"
                  v-model="item.tipoInversion.clave"
                  class="mb-3"
                  text-field="valor"
                  value-field="clave"
                  @change="cambiosInversion[index] = true"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Tipo de subinversión: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  :options="subInversion"
                  v-model="item.subTipoInversion.clave"
                  class="mb-3"
                  text-field="valor"
                  value-field="clave"
                  @change="cambiosInversion[index] = true"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="País de la inversión: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  :options="pais"
                  v-model="item.localizacionInversion.pais"
                  class="mb-3"
                  text-field="nombre"
                  value-field="clave"
                  @change="cambiosInversion[index] = true"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="RFC">Institución, razón social</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.localizacionInversion.institucionRazonSocial"
                  type="text"
                  placeholder="Ingrese..."
                  @change="cambiosInversion[index] = true"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="RFC">RFC:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.localizacionInversion.rfc"
                  type="text"
                  placeholder="Ingrese..."
                  @change="cambiosInversion[index] = true"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group>
                <label for="RFC">Número de cuenta Contrato:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.numeroCuentaContrato"
                  type="text"
                  @change="cambiosInversion[index] = true"
                  placeholder="Ingrese..."
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="5" v-if="tipoDeclaracion === 'INICIAL'">
              <b-form-group>
                <label for="RFC">Saldo situación actual:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.saldoSituacionActual.valor"
                  type="text"
                  placeholder="Ingrese..."
                  @change="cambiosInversion[index] = true"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="tipoDeclaracion === 'INICIAL'">
              <b-form-group>
                <label for="RFC">Moneda:</label>
                <b-form-input
                  v-model="item.saldoSituacionActual.moneda"
                  type="text"
                  value="MXN"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="5" v-if="tipoDeclaracion === 'MODIFICACION'">
              <b-form-group>
                <label for="RFC">Saldo situación actual:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.saldoDiciembreAnterior.valor"
                  type="text"
                  placeholder="Ingrese..."
                  @change="cambiosInversion[index] = true"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="tipoDeclaracion === 'MODIFICACION'">
              <b-form-group>
                <label for="RFC">Moneda:</label>
                <b-form-input
                  v-model="item.saldoDiciembreAnterior.moneda"
                  type="text"
                  value="MXN"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="5" v-if="tipoDeclaracion === 'CONCLUSION'">
              <b-form-group>
                <label for="RFC">Saldo situación actual:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  v-model="item.saldoFechaConclusion.valor"
                  type="text"
                  placeholder="Ingrese..."
                  @change="cambiosInversion[index] = true"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="tipoDeclaracion === 'CONCLUSION'">
              <b-form-group>
                <label for="RFC">Moneda:</label>
                <b-form-input
                  v-model="item.saldoFechaConclusion.moneda"
                  type="text"
                  value="MXN"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <br />
        <!-- FIN formulario -->
        <br />
        <hr />
        <!--Titular-->
        <b-col md="12">
          <b-col md="12">
            <h6>Titulares:</h6>
          </b-col>

          <b-list-group sm="12">
            <b-list-group-item
              v-for="(item_titular, i) in item.titular"
              :key="i"
            >
              <p style="text-align: center">{{ item_titular.valor }}</p>
              <b-row style="text-align: center">
                <b-col>
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="danger"
                    size="sm"
                    @click="eliminarTitular(index)"
                    >Eliminar titular</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group-item>
            <br />
            <b-modal
            v-if="status !== 'Concluida'"
              v-model="mostrar"
              title="Nuevo titular"
              cancel-title="Cancelar"
              ok-title="Generar"
              @ok="agregarTitular(index)"
            >
              <b-form-select v-model="tmpTitular" :options="t"></b-form-select>
            </b-modal>
          </b-list-group>
          <b-col md="12">
            <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
              >Agregar Titular</b-button
            >
          </b-col>
        </b-col>
        <!-- fin t -->

  <hr />

        <b-col md="12">
          <b-col md="12">
            <h6>Terceros:</h6>
          </b-col>
          <b-list-group sm="12">
            <b-list-group-item
              v-for="(elemento, indice) in item.tercero"
              :key="indice"
            >
              <b-row>
                <b-col md="4">
                  <b-form-group label="Tipo de persona: ">
                    <b-form-select
                    :disabled="status === 'Concluida'"
                      :options="tipoPersona"
                      v-model="elemento.tipoPersona"
                      class="mb-3"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <label for="RFC">Razón social:</label>
                    <b-form-input
                    :disabled="status === 'Concluida'"
                      type="text"
                      v-model="elemento.nombreRazonSocial"
                      placeholder="Ingrese..."
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <label for="RFC">RFC:</label>
                    <b-form-input
                    :disabled="status === 'Concluida'"
                      type="text"
                      v-model="elemento.rfc"
                      placeholder="Ingrese..."
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-button
                  v-if="status !== 'Concluida'"
                    size="sm"
                    variant="primary"
                    @click="
                      guardarTercero(elemento._id, index, indice, item._id)
                    "
                    :disabled="enviando"
                    >Guarda tercero</b-button
                  >
                  <br />
                </b-col>
                <b-col md="6" class="text-right">
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="danger"
                    size="sm"
                    @click="
                      eliminarTercero(elemento._id, index, indice, item._id)
                    "
                    >Eliminar tercero</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>

          <br />
          <b-row>
            <b-col md="6">
              <b-button
              v-if="status !== 'Concluida'"
                size="sm"
                variant="primary"
                @click="nuevoTercero(item._id, index)"
                :disabled="enviando"
                >Nuevo tercero</b-button
              >
              <br />
            </b-col>

            <b-col md="12">
              <hr />
              <br />
            </b-col>

            <b-col md="6" class="text-right">
              <b-button
              v-if="status !== 'Concluida'"
                size="sm"
                variant="primary"
                @click="modificarInversion(item._id, index)"
                :disabled="enviando"
                >Guarda Inversión</b-button
              >
              <br />
              <p v-if="cambiosInversion[index]" class="error-text">
                <i>No se han guardado los cambios</i>
              </p>
              <br />
            </b-col>
            <b-col md="6" class="text-left">
              <b-button
              v-if="status !== 'Concluida'"
                variant="danger"
                size="sm"
                @click="eliminarInversion(item._id, index)"
                >Eliminar Inversión</b-button
              >
            </b-col>
          </b-row>
        </b-col>

        <br />
      </b-list-group-item>
    </b-list-group>

    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoElemento()"
          >Agregar inversión</b-button
        >
      </b-col>
    </b-row>

    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label for="funcion">ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="valores.aclaracionesObservaciones"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarAclaraciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-if="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2">
        <b-button
          variant="secondary"
          @click="verSeccion(11)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
          class="pull-right"
          variant="secondary"
          @click="verSeccion(13)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

import { paises } from "../../../store/paises";

export default {
  props: ["valores", "tipoDeclaracion", "status"],
  components: {
    Datetime,
    Loader
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      cambiosInversion: [],
      contadorTitular: 0,
      contadorTecero: 0,
      tipoOperacion:  ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      tipoInversion: [
        { clave: "BANC", valor: "BANCARIA" },
        { clave: "FINV", valor: "FONDOS DE INVERSIÓN" },
        { clave: "ORPM", valor: "ORGANIZACIONES PRIVADAS Y/O MERCANTILES" },
        { clave: "POMM", valor: "POSESIÓN DE MONEDAS Y/O METALES" },
        { clave: "SEGR", valor: "SEGUROS" },
        { clave: "VBUR", valor: "VALORES BURSÁTILES" },
        { clave: "AFOT", valor: "AFORES Y OTROS" }
      ],
      subInversion: [
        { clave: "CNOM", valor: "CUENTA DE NÓMINA" },
        { clave: "CAHO  ", valor: "CUENTA DE AHORRO" },
        { clave: "CCHE", valor: "CUENTA DE CHEQUES" },
        { clave: "CMAS", valor: "CUENTA MAESTRA" },
        { clave: "CEJE", valor: "CUENTA EJE" },
        { clave: "DPLA", valor: "DEPÓSITO A PLAZOS" },
        { clave: "SOIN", valor: "SOCIEDADES DE INVERSIÓN" },
        { clave: "IFEX", valor: "INVERSIONES FINANCIERAS EN EL EXTRANJERO" },
        { clave: "ACCI", valor: "ACCIONES" },
        { clave: "CSAH", valor: "CAJAS DE AHORRO" },
        { clave: "CENT", valor: "CENTENARIOS" },
        { clave: "DIVS", valor: "DIVISAS" },
        { clave: "MONN", valor: "MONEDA NACIONAL" },
        { clave: "ONZT", valor: "ONZAS TROY" },
        { clave: "CRIP", valor: "CRIPTOMONEDAS" },
        { clave: "SSIN", valor: "SEGURO DE SEPARACIÓN INDIVIDUALIZADO" },
        { clave: "SEGI", valor: "SEGURO DE INVERSIÓN" },
        { clave: "SEGV", valor: "SEGURO DE VIDA" },
        { clave: "ADER", valor: "ACCIONES Y DERIVADOS" },
        { clave: "ABAN", valor: "BONOS GUBERNAMENTALES" },
        { clave: "PCOM", valor: "PAPEL COMERCIAL" },
        { clave: "AFOR", valor: "AFORES" },
        { clave: "FIDE", valor: "FIDEICOMISOS" },
        { clave: "CTES", valor: "CERTIFICADOS DE LA TESORERÍA" },
        { clave: "PFTE", valor: "PRÉSTAMOS A FAVOR DE UN TERCERO" },
        { clave: "BGUB", valor: "BONOS GUBERNAMENTALES" }
      ],
      pais: paises,
      titulales: [
        { clave: "DEC", valor: "DECLARANTE" },
        { clave: "CYG", valor: "CONYUGE" },
        { clave: "CBN", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CVV", valor: "CONVIVIENTE" },
        { clave: "DEN", valor: "DEPENDIENTE ECONÓMICO" },
        { clave: "CTER", valor: "COPROPIEDAD CON TERCEROS" }
      ],
      tmpTitular: "",
      mostrar: false,
      t: [
        "DECLARANTE",
        "CONYUGE",
        "CONCUBINA O CONCUBINARIO",
        "CONVIVIENTE",
        "DEPENDIENTE ECONÓMICO",
        "COPROPIEDAD CON TERCEROS"
      ],
      tipoPersona: ["FISICA", "MORAL"]
    };
  },
  methods: {
    ////////////////////////////////////////////////////////////////tercero//////////////////////////////////////////////////////

    nuevoTercero(id, index) {
      let nuevo = {
        _id: this.contadorTecero,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
      };
      this.valores.inversion[index].tercero.push(nuevo);

      this.contadorTecero++;
    },

    guardarTercero(idTercero, indexInversion, indexTercero, idInversion) {
      if (idTercero.length > 3) {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/inversionesCuentasValores/" +
              this.$route.params.id +
              "/inversion/" +
              idInversion +
              "/tercero/" +
              idTercero,
            {
              tipoPersona: this.valores.inversion[indexInversion].tercero[
                indexTercero
              ].tipoPersona,
              nombreRazonSocial: this.valores.inversion[indexInversion].tercero[
                indexTercero
              ].nombreRazonSocial,
              rfc: this.valores.inversion[indexInversion].tercero[indexTercero]
                .rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
          
            }
            this.enviando = false;
            this.cambios = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      } else {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/inversionesCuentasValores/" +
              this.$route.params.id +
              "/inversion/" +
              idInversion +
              "/tercero",
            { tipoPersona: "FISICA", nombreRazonSocial: "alex", rfc: "abx" },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
       
              this.valores.inversion[indexInversion].tercero[indexTercero]._id =
                res.data.tercero._id;
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo tercero."
            });
            this.enviando = false;
          });
      }
    },

    eliminarTercero(idTercero, indexInversion, indexTercero, idInversion) {
      if (idTercero.length > 3) {
        swal({
          text: "¿Está seguro en eliminar el tercero?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/inversionesCuentasValores/" +
                  this.$route.params.id +
                  "/inversion/" +
                  idInversion +
                  "/tercero/" +
                  idTercero,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
          
          
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });

                  this.valores.inversion[indexInversion].tercero.splice(
                    indexTercero,
                    1
                  );

                  this.contadorTecero--;
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo eliminar tercero."
                });
                this.enviando = false;
              
              
              });
          }
        });
      } else {
        this.valores.inversion[indexInversion].tercero.splice(indexTercero, 1);

        this.contadorTecero--;
      }
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////////////titulares////////////////////////////////////////

    encuentraValorTitular(indexInversion, indexTitular) {
      let indice;
      indice = this.titulales.findIndex(
        x =>
          x.clave ===
          this.valores.inversion[indexInversion].titular[indexTitular].clave
      );
      this.valores.inversion[indexInversion].titular[
        indexTitular
      ].valor = this.titulales[indice].valor;
    },

    nuevoTitular(id, index) {
      let nuevo = {
        _id: this.contadorTitular,
        clave: null,
        valor: null
      };
      this.valores.inversion[index].titular.push(nuevo);

      this.contadorTitular++;
    },
    agregarTitular(index) {
      let indice = this.titulales.findIndex(x => x.valor == this.tmpTitular);
      let nuevoTitular = {
        clave: this.titulales[indice].clave,
        valor: this.tmpTitular
      };
      this.valores.inversion[index].titular.push(nuevoTitular);
    
     axios
        .post(
          
          this.httpURL +
            "/declaraciones/V2/inversionesCuentasValores/" +
            this.$route.params.id +
            "/inversion/" +
            this.valores.inversion[index]._id +
            "/titular",

          {
            titularClave: this.titulales[indice].clave,
            titularValor: this.tmpTitular
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },

    eliminarTitular(index) {
      
        swal({
          text: "¿Está seguro en eliminar la actividad?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/inversionesCuentasValores/" +
                  this.$route.params.id +
                  "/inversion/" +
                  this.valores.inversion[index]._id +
                  "/titular/" +
                  this.valores.inversion[index].titular[index]._id,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
               
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });

                  this.valores.inversion[index].titular.splice(
                    index,
                    1
                  );

                  this.contadorTitular--;
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo guardar la sección."
                });
                this.enviando = false;
              
              });
          }
        });
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////inversiones/////////////////////////////////////////////////////////////////

    eliminarInversion(idInversion, index) {
      swal({
        text: "¿Está seguro en eliminar la inversión?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/inversionesCuentasValores/" +
                this.$route.params.id +
                "/inversion/" +
                idInversion,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
          
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.valores.inversion.splice(index, 1);

                this.cambiosInversion.splice(index, 1);
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
          
            });
        }
      });
    },

    nuevoElemento() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/inversionesCuentasValores/" +
            this.$route.params.id +
            "/inversion",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.valores.inversion.push(res.data.inversion);
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo crear nuevo elemento."
          });
          this.enviando = false;
        });
    },

    modificarInversion(id, index) {
      if (this.tipoDeclaracion === "INICIAL") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/inversionesCuentasValores/" +
              this.$route.params.id +
              "/inversion/" +
              id,
            {
              tipoOperacion: this.valores.inversion[index].tipoOperacion,
              tipoInversionClave: this.valores.inversion[index].tipoInversion
                .clave,
              tipoInversionValor: this.valores.inversion[index].tipoInversion
                .valor,
              subTipoInversionClave: this.valores.inversion[index]
                .subTipoInversion.clave,
              subTipoInversionValor: this.valores.inversion[index]
                .subTipoInversion.valor,
              numeroCuentaContrato: this.valores.inversion[index]
                .numeroCuentaContrato,
              localizacionPais: this.valores.inversion[index]
                .localizacionInversion.pais,
              localizacionInstitucionRazonSocial: this.valores.inversion[index]
                .localizacionInversion.institucionRazonSocial,
              localizacionRFC: this.valores.inversion[index]
                .localizacionInversion.rfc,

              saldoSituacionActualValor: this.valores.inversion[index]
                .saldoSituacionActual.valor,
              saldoSituacionActualMoneda: "MXN"
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
 
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosInversion[index] = false;
              this.$forceUpdate();
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo editar la inversión."
            });
            this.enviando = false;
          });
      } else if (this.tipoDeclaracion === "MODIFICACION") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/inversionesCuentasValores/" +
              this.$route.params.id +
              "/inversion/" +
              id,
            {
              tipoOperacion: this.valores.inversion[index].tipoOperacion,
              tipoInversionClave: this.valores.inversion[index].tipoInversion
                .clave,
              tipoInversionValor: this.valores.inversion[index].tipoInversion
                .valor,
              subTipoInversionClave: this.valores.inversion[index]
                .subTipoInversion.clave,
              subTipoInversionValor: this.valores.inversion[index]
                .subTipoInversion.valor,
              numeroCuentaContrato: this.valores.inversion[index]
                .numeroCuentaContrato,
              localizacionPais: this.valores.inversion[index]
                .localizacionInversion.pais,
              localizacionInstitucionRazonSocial: this.valores.inversion[index]
                .localizacionInversion.institucionRazonSocial,
              localizacionRFC: this.valores.inversion[index]
                .localizacionInversion.rfc,

              saldoDiciembreAnteriorValor: this.valores.inversion[index]
                .saldoDiciembreAnterior.valor,
              saldoDiciembreAnteriorMoneda: "MXN"
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosInversion[index] = false;
              this.$forceUpdate();
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo editar la inversión."
            });
            this.enviando = false;
          });
      } else if (this.tipoDeclaracion === "CONCLUSION") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/inversionesCuentasValores/" +
              this.$route.params.id +
              "/inversion/" +
              id,
            {
              tipoOperacion: this.valores.inversion[index].tipoOperacion,
              tipoInversionClave: this.valores.inversion[index].tipoInversion
                .clave,
              tipoInversionValor: this.valores.inversion[index].tipoInversion
                .valor,
              subTipoInversionClave: this.valores.inversion[index]
                .subTipoInversion.clave,
              subTipoInversionValor: this.valores.inversion[index]
                .subTipoInversion.valor,
              numeroCuentaContrato: this.valores.inversion[index]
                .numeroCuentaContrato,
              localizacionPais: this.valores.inversion[index]
                .localizacionInversion.pais,
              localizacionInstitucionRazonSocial: this.valores.inversion[index]
                .localizacionInversion.institucionRazonSocial,
              localizacionRFC: this.valores.inversion[index]
                .localizacionInversion.rfc,

              saldoFechaConclusionValor: this.valores.inversion[index]
                .saldoFechaConclusion.valor,
              saldoFechaConclusionMoneda: "MXN"
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosInversion[index] = false;
              this.$forceUpdate();
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo editar la inversión."
            });
            this.enviando = false;
          });
      }
    },
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    actualizarAclaraciones() {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/inversionesCuentasValores/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.valores.aclaracionesObservaciones,
            ninguno: ""
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
    
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
  },

  created() {
    if (this.valores.inversion.length > 0) {
      this.valores.inversion.forEach(Element => {
        this.cambiosInversion.push(false);
      });
    }
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
